'use client'

import {
  useBooleanFlagValue,
  useStringFlagValue,
  useObjectFlagValue,
} from '@openfeature/react-sdk'
import { getFeatureClient } from './openFeature'

export const FLAGS = {
  enableClickToPay: 'enable-click-to-pay',
  orerSubmitVersion: 'order-submit-version',
  gfoOrderEnabled: 'gfo-order-attribution',
  enableAllowance: 'enable-allowance',
  enablePageHeaderCorporateButton: 'enable-page-header-corporate-button',
  enableRokt: 'enable-rokt',
  enableWhitelabelCatering: 'enable-whitelabel-catering',
  cateringLoyaltyItemFilter: 'catering-loyalty-item-filter',
  cateringUnderTenItemFilter: 'catering-under-10-item-filter',
}

export const useFlagBoolean = (flagKey, defaultValue = false, opts = {}) => {
  const feature = getFeatureClient()
  return feature.getBooleanValue(flagKey, defaultValue, opts)
}

export const useFlagString = (flagKey, defaultValue = '', opts = {}) => {
  const feature = getFeatureClient()
  return feature.getStringValue(flagKey, defaultValue, opts)
}

export const useFlagObject = (flagKey, defaultValue) => {
  const feature = getFeatureClient()
  return feature.getObjectValue < T > (flagKey, defaultValue)
}

export const useClickToPayEnabled = () => {
  const feature = getFeatureClient()
  return feature.getBooleanValue(FLAGS.enableClickToPay, false)
}

export const useGfoOrderEnabled = () => {
  const feature = getFeatureClient()
  return feature.getBooleanValue(FLAGS.gfoOrderEnabled, false)
}

export const getOrderSubmitVersion = (opts = {}) =>
  useFlagString(FLAGS.orerSubmitVersion, '2', opts)

export const useAllowanceEnabled = () => {
  const feature = getFeatureClient()
  return feature.getBooleanValue(FLAGS.enableAllowance, false)
}

export const usePageHeaderCorporateButtonEnabled = () => {
  const feature = getFeatureClient()
  return feature.getBooleanValue(FLAGS.enablePageHeaderCorporateButton, false)
}

export const useRoktEnabled = () => {
  const feature = getFeatureClient()
  return feature.getBooleanValue(FLAGS.enableRokt, false)
}

export const useWhitelabelCateringEnabled = () => {
  const feature = getFeatureClient()
  return feature.getBooleanValue(FLAGS.enableWhitelabelCatering, false)
}

export const useCateringLoyaltyFilterEnabled = () => {
  const feature = getFeatureClient()
  return feature.getBooleanValue(FLAGS.cateringLoyaltyItemFilter, false)
}

export const useCateringUnderTenFilterEnabled = () => {
  const feature = getFeatureClient()
  return feature.getBooleanValue(FLAGS.cateringUnderTenItemFilter, false)
}
